import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { tryToConfirmEmail } from '../actions/actions.export.js';

class ConfirmMyEmail extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);
  }


  componentDidMount(){
    window.document.title = "Confirm Email - Pattycake";
    const { dispatch, user } = this.props;
    console.log(user);
    if(user.isLoggedIn){
      // try to confirm email
      dispatch(tryToConfirmEmail({
        code: this.props.match.params.code
      }));
    }
  }

  render(){
    const { user } = this.props;

    return <div className="landing">
      {
        user.isLoggedIn && user.tryingToConfirmEmail &&
        <div className="dead-center">
          <i className="far fa-spinner-third fa-spin fa-4x text-primary"/>
        </div>
      }
    </div>
  }
}


const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(ConfirmMyEmail);



// WEBPACK FOOTER //
// ./src/routes/ConfirmMyEmail.js